import request from './request';

export const login = async (data) => {
  return request.post('/auth/login', data);
};

export const logout = () => request.post('/auth/logout');

export const getCaptcha = () => {
  return request.get('/auth/captcha');
};

export const refreshToken = (refreshToken) =>
  request.post('/auth/refresh', { refreshToken });
